import axios from 'axios'
import { makeQueryString } from '@/utils/Query.js'
const API_BASE_URL = process.env.VUE_APP_API_URL;

const config = {
    baseUrl: API_BASE_URL + "/homepage/news/"
};

const newsAPIDFN = {
    newsAPI: (APIName, conditions, paths) => {
        return newsAPI[APIName](conditions, paths);
    }
};

const newsAPI = {
    API_BASE_URL: `${API_BASE_URL}`,
    selectPressRelease: (conditions, paths) => {
        const uri = paths || "news/selectPressRelease"
        return axios.get(
            `${config.baseUrl}${uri}${makeQueryString(conditions)}`
        );
    },
    getPressRelease: (conditions, paths) => {
        const uri = paths || "news/getPressRelease"
        return axios.get(
            `${config.baseUrl}${uri}${makeQueryString(conditions)}`
        );
    },
    selectNewsRoom: (conditions, paths) => {
        const uri = paths || "news/selectNewsRoom"
        return axios.get(
            `${config.baseUrl}${uri}${makeQueryString(conditions)}`
        );
    },
    getNewsRoom: (conditions, paths) => {
        const uri = paths || "news/getNewsRoom"
        return axios.get(
            `${config.baseUrl}${uri}${makeQueryString(conditions)}`
        );
    },
    selectFactBook: (conditions, paths) => {
        const uri = paths || "news/selectFactBook"
        return axios.get(
            `${config.baseUrl}${uri}${makeQueryString(conditions)}`
        );
    },
    getFactBook: (conditions, paths) => {
        const uri = paths || "news/getFactBook"
        return axios.get(
            `${config.baseUrl}${uri}${makeQueryString(conditions)}`
        );
    },
    selectHiddenSharingAngel: (conditions, paths) => {
        const uri = paths || "news/selectHiddenSharingAngel"
        return axios.get(
            `${config.baseUrl}${uri}${makeQueryString(conditions)}`
        );
    },
    getHiddenSharingAngel: (conditions, paths) => {
        const uri = paths || "news/getHiddenSharingAngel"
        return axios.get(
            `${config.baseUrl}${uri}${makeQueryString(conditions)}`
        );
    },
};

export { newsAPIDFN, newsAPI };
